import { useAuth } from "@clerk/react-router";
import { useEffect, useRef } from "react";
import { assertBlankConversation } from "@noa/client-store";
import { useHasTokenGenerator, useSetTokenGenerator } from "@noa/client-store";

export const useInitTokenGenerator = () => {
  const { getToken, isSignedIn } = useAuth();
  const setTokenGenerator = useSetTokenGenerator();
  const hasTokenGenerator = useHasTokenGenerator();
  const isInitializing = useRef(false);

  useEffect(() => {
    if (!isSignedIn || hasTokenGenerator || isInitializing.current) {
      return;
    }
    isInitializing.current = true;
    setTokenGenerator(getToken);
  }, [getToken, setTokenGenerator, hasTokenGenerator, isSignedIn]);
};

/**
 * Web binding for the blank-chat routes ("/" and "/predefined-tasks"): asserts a blank session on
 * entry. Runs once auth + the token generator are ready (avoids a 401 from firing the init before
 * the Clerk token getter is set). React Router remounts these screens on every navigation to them,
 * so the assertion re-runs each time — it is idempotent, and keeps an already-pristine session.
 */
export const useAssertBlankConversation = () => {
  const { isSignedIn } = useAuth();
  const hasTokenGenerator = useHasTokenGenerator();

  useEffect(() => {
    if (!isSignedIn || !hasTokenGenerator) return;
    assertBlankConversation();
  }, [isSignedIn, hasTokenGenerator]);
};
